const dataTypes = {
    policy: 'Kötvény',
    mepar: 'MePAR',
    report: 'Kárakta',
};

// eslint-disable-next-line import/prefer-default-export
export { dataTypes };
